import $ from 'zepto';
import { onDocumentReady, expose, get } from '../../main';
import {
  addPopup,
  getHashId,
  getAjaxTooltipContent,
  getComputedId,
  getPopupId,
  addRelExtension,
} from './popups/popups';

import {
  $$$,
} from '../../utils/legacy';

import {
  popupCache,
} from '../../utils/legacy/constants';

import { objectHasOwnProperty } from '../../utils';

const $body = $(document.body);
export function hideAll() {
  Object.keys(popupCache).forEach((key) => {
    if (objectHasOwnProperty(popupCache, key)) {
      popupCache[key].hide();
    }
  });
}

export function initPopups() {
  /**
   Help Popups Object
   @object AutoPopups
   @return {Object}
   @private
   */
  const AutoPopups = (function AutoPopups() {
    const registeredSelectors = {};

    /**
     Add event handlers for each selector
     NOTE: Temporary handler and "rel" attribute.
     Don't have time to refactor rel="tooltip" code in freemarker pages to make sure they
     do not have xtip markup in them
     @method addEvents
     @param {String} selector jQuery selector for targeted links
     @param {Function} idCallback Method to run in order to obtain the ID of the popup.
     @private
     */
    /**
     Add event handlers for each selector
      @method addEvents
      @param {String} selector jQuery selector for targeted links
      @param {Function} idCallback Method to run in order to obtain the ID of the popup.
      @param {boolean} persistPopup should the popup persist when the user moves mouse over it?
      @param {Function} onShow callback method to run when popup is shown
      @private
      */
    function addEvents(selector, idCallback, persistPopup, onShow, position) {
      registeredSelectors[selector] = {
        idCallback,
        persistPopup,
        onShow,
        position,
      };
    }

    function addEventsGetMessage(selector, idCallback, persistPopup) {
      registeredSelectors[selector] = {
        idCallback,
        persistPopup,
        idExtension: '-tooltip',
      };
    }

    function attachGlobalClickHandler(context) {
      $(context || 'body').delegate('a[rel], button[rel]', 'click', function bodyDelegate(event) {
        const elementRel = $(this).attr('rel');
        hideAll();
        if (elementRel === 'xvx-tooltip') {
          const rel = registeredSelectors[elementRel];
          if (rel) {
            const element = this;
            const $element = $(this);
            let popupId = rel.idCallback(element.href) || rel.idCallback($element.data('target')) || this.tooltipId;
            const popupOptions = {
              type: elementRel,
              target: $element,
              persist: rel.persistPopup,
              bindTargetHover: 0,
              onShow: rel.onShow,
              zIndex: 200,
              position: $element.attr('data-xvx-tooltip-position') || rel.position,
              size: $element.attr('data-xvx-tooltip-size'),
              hideOnBodyClick: true,
              window: $element.attr('data-xvx-tooltip-bounding-element-selector') || window,
              closeBox: $element.attr('data-xvx-tooltip-close') || true,
            };
            popupId = getPopupId(popupId);
            /*
             begin hacks
             the following is hacky and only done this way to avoid an entire refactoring of existing tooltips.
             */
            // if this is an xvx-tooltip (the newest tooltip type), then let's get the message straight away
            // because an element with an ID = popupID will contain the popup contents
            if (elementRel.indexOf('xvx-tooltip') !== -1) {
              popupOptions.message = $$$(popupId);
              popupOptions.type = 'tooltip';
            }

            if ($element.hasClass('xvx-tooltip-responsive')) {
              popupOptions.width = 'auto';
            }

            popupId += addRelExtension(rel.idExtension, popupId);
            // end hacks
            // store the popupId as a custom attribute
            // used when the popupId was dynamically created.
            this.tooltipId = popupId;

            const popup = popupCache[popupId];

            if (popup) { // if the popup already exists, show the existing popup
              // pass in the element that triggered this popup
              // we pass the element in because we have circumstances where the original element was destroyed
              // because of an ajax request reloading the information
              popup.show(this);
            } else { // create a new popup
              addPopup(popupId, element, popupOptions).show();
            }
          }
          event.preventDefault();
        }
      });
    }

    /**
     Init Method, which initializes event handlers bindings for Help Popups
     @method init
     @private
     */
    function initAutoPopups($context) {
      if (!get().popupInitialized || $context !== $body) {
        expose({ popupInitialized: true });
        addEventsGetMessage('xvx-tooltip', getHashId, 0);
        addEventsGetMessage('xvx-tooltip-persist', getHashId, 1);
        addEvents('xvx-tooltip-ajax', getComputedId, 0, getAjaxTooltipContent); // tooltip which gets content via ajax
        // tooltip which gets content via ajax
        addEvents('xvx-tooltip-persist-ajax', getComputedId, 1, getAjaxTooltipContent);
        attachGlobalClickHandler($context);
      }
    }

    /**
     Public Interface for this object
     @object
     @return {Object}
     @public
     */
    return {
      initAutoPopups,
    };
  }());

  /**
   Initialize Help Popups
   @method init
   @private
   */
  function init($context) {
    AutoPopups.initAutoPopups($context);
  }

  /**
   Public Interface for this object
   @object
   @return {Object}
   @public
   */
  return {
    /**
     Init Help Popups
     @method init
     @public
     */
    init,

    /**
     Add new popup and register the popup with xoom.UIManager

     @method addPopup
     @param {String} popupId ID that will be assigned to the popup
     @param {String} targetSelector jQuery selector which defines the element that the popup will be anchored to
     @param {Object} newOptions Options hash
     @return {Object} pointer to instance of newly created Popup object
     @public
     */
    add: addPopup,
    get(popupId) {
      return popupCache[popupId];
    },
    hidePopup(popupId) {
      const popup = this.get(popupId);
      if (popup) {
        popup.hide();
      }
    },
    hideAll,
    destroy(popupId) {
      const popup = this.get(popupId);

      if (popup) {
        popup.destroy();
        delete popupCache[popupId];
      }
    },
  };
}

// TODO: Add context implementation
onDocumentReady('Popups', () => {
  initPopups().init($body);
});

export default {
  initPopups,
  hideAll,
};
